var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.list_gridOptions)?_c('vxe-grid',_vm._b({ref:"list",on:{"toolbar-button-click":_vm.list_toolbarButtonClickEvent}},'vxe-grid',_vm.list_gridOptions,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }